import { useFormik } from "formik";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { Input, Form } from "components/Form";
import { Button } from "components/Button";
import { Loader } from "components/Loader";
import { HelpCenterSubCardContainer } from "../HelpCenter.styles";
import { initialValues, validationSchema } from "../../validation";
import { sendContactOrFeatureDetails } from "../../service";
import { parseErrorMessage } from "utils";
import { toast } from "Layout/slice";
import { helpcenterRequestTypes } from "utils/constants";
import { userDetailSelect } from "Layout/slice/selector";
import { loggedInState } from "features/Auth/slice/selector";
import { Heading } from "style/components/Heading.styles";
import { IconClose } from "assets/icons";

const RequestFeature = ({ handleMenuClose }) => {
  const dispatch = useDispatch();
  const userDetail = useSelector(userDetailSelect);
  const isLoggedInState = useSelector(loggedInState);

  const handleSubmit = async (values) => {
    try {
      await sendContactOrFeatureDetails({
        ...values,
        request_type: helpcenterRequestTypes.requestFeature,
      });
      formik.resetForm();
      dispatch(
        toast({
          type: "info",
          body: "The request has been sent, Thank you!",
        })
      );
    } catch (error) {
      console.error(error);
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  const formik = useFormik({
    initialValues: initialValues({
      name: userDetail.first_name + " " + userDetail.last_name,
      email: userDetail.email,
      subject: "",
    }),
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <HelpCenterSubCardContainer>
      <div className="wrapper">
        <div className="header">
          <Heading>Request a Feature</Heading>
          <IconClose
            fill="#048AF5"
            className="close-icon"
            height={24}
            width={24}
            onClick={handleMenuClose}
          />
        </div>

        <Form className="form" onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={6}>
              <Input
                disabled={isLoggedInState}
                label="Name*"
                placeholder="Enter Name"
                isInvalid={formik.touched.name && formik.errors.name}
                {...formik.getFieldProps("name")}
              />
            </Col>
            <Col md={6}>
              <Input
                disabled={isLoggedInState}
                label="Email*"
                placeholder="Enter Email"
                isInvalid={formik.touched.email && formik.errors.email}
                {...formik.getFieldProps("email")}
              />
            </Col>

            <Input
              label="Feature Subject*"
              placeholder="Enter Subject"
              isInvalid={formik.touched.subject && formik.errors.subject}
              {...formik.getFieldProps("subject")}
            />

            <Input
              label="Description*"
              type="textarea"
              placeholder="Enter Description......"
              className="bug-description-input"
              rows={6}
              as="textarea"
              isInvalid={
                formik.touched.description && formik.errors.description
              }
              {...formik.getFieldProps("description")}
            />

            <div className="btn-submit">
              <Button type="submit" disabled={!formik.isValid}>
                {formik.isSubmitting ? <Loader className="on-btn" /> : "Submit"}
              </Button>
            </div>
          </Row>
        </Form>
      </div>
    </HelpCenterSubCardContainer>
  );
};

RequestFeature.propTypes = {
  handleMenuClose: PropTypes.func,
};

export { RequestFeature };
